import _each from "lodash/each";

export default class PinModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        eventType: null,
        multiImageNum: 0,
        multiImageColor: ""
      },

      getters: {},

      // Mutations ----------------------------------------
      mutations: {
        registScrollEventType(state, payload) {
          state.eventType = payload.eventType;
        },

        beforeMultiImageChange(state, payload) {
          state.multiImageNum = payload.num;
          state.multiImageColor = payload.color;
        }
      },
      // Actions ----------------------------------------
      actions: {
        // 使用イベントの登録
        registScrollEventType({ commit, state }, payload) {
          commit("registScrollEventType", payload);
        },
        beforeMultiImageChange({ commit, state }, payload) {
          commit("beforeMultiImageChange", payload);
        }
      }
    };
  }

  getModule() {
    return this.module;
  }
}
